export const MICHIGAN_ORG_ALIAS = 'us-mi'

export const TERMS_AND_CONDITIONS_URL =
  'https://www.michigan.gov/treasury/about/privacy-notices/michigan-disclosure-request-system'

export const TOS_ACKNOWLEDGED_KEY = 'ivix.tosAcknowledged'

export const isMichiganUser = (organization?: unknown): boolean =>
  typeof organization === 'string' && organization.trim().toLowerCase() === MICHIGAN_ORG_ALIAS

export const hasAcknowledgedTerms = (): boolean => {
  try {
    return sessionStorage.getItem(TOS_ACKNOWLEDGED_KEY) === 'true'
  } catch {
    return false
  }
}

export const markTermsAcknowledged = (): void => {
  try {
    sessionStorage.setItem(TOS_ACKNOWLEDGED_KEY, 'true')
  } catch {
    return
  }
}

export const clearTermsAcknowledged = (): void => {
  try {
    sessionStorage.removeItem(TOS_ACKNOWLEDGED_KEY)
  } catch {
    return
  }
}
